import React from 'react'
import { withFirebase } from '../../components/Fb'
import moment from 'moment-timezone'

// reactstrap components
import { Row, Col, Button } from 'reactstrap'
import FalconModal from '../../components/Inputs/FalconModal'
import { getActivitySchema, getActivityUISchema } from '../../components/Inputs/dataschemas'
// import Typography from '@material-ui/core/Typography'
// import ReactTable from 'react-table'
// import ReactTable from '../../components/Lists/ReactTableWrapper'
// core components
// import moment from 'moment'
import 'moment/locale/fi'
// import { filterCaseInsensitive } from '../../components/FalconTable'
import ActivityDetailsWizard from '../../components/Details/ActivityDetailsWizard'
import { getPanelScrollTop, setPanelScrollTop, restorePanelScroll } from '../../components/utils/scrollPanel'
import ActivityDetails from '../../components/Details/ActivityDetails2'
import EditButton from '../../components/Buttons/EditButton'
import DeleteButton from '../../components/Buttons/DeleteButton'
import ParticipantsButton from '../../components/Buttons/ParticipantsButton'
import CopyButton from '../../components/Buttons/CopyButton'
import { buildActivityCopy } from '../../components/utils/activityCopy'
import ActivityCopyDialog from '../../components/Dialogs/ActivityCopyDialog'
import ActivityReservationReleaseDialog from '../../components/Dialogs/ActivityReservationReleaseDialog'
import { createdReservations } from '../../components/utils/activityReservations'
import { imageThumbnailUrl } from '../../components/utils/images'
import {
  cancellationEndError,
  effectiveCancellationEnd,
  hasOwnCancellationEnd,
} from '../../components/utils/activityCancellationDeadline'
import { DataGrid, useGridApiContext } from '@mui/x-data-grid'
//import SettingsIcon from '@material-ui/icons/Settings'
import { Box, Chip, Dialog, DialogTitle, DialogContent, FormControlLabel, IconButton, Switch } from '@mui/material'
import BugReportIcon from '@mui/icons-material/BugReport'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment'
import { MobileDateTimePicker } from '@mui/x-date-pickers/MobileDateTimePicker'
import Infobox from '../../components/Infos/Infobox'
import { DEFAULT_SPORTS, DEFAULT_TYPES } from '../../sports'
import { isActivityPast, wallClockNow } from '../../components/utils/activityPast'
//import PersonSearch from '../../components/Inputs/PersonSearch'

const STATES = [
  { label: 'Luonnos', value: 'draft' },
  { label: 'Julkaistu', value: 'published' },
  { label: 'Peruttu', value: 'cancelled' },
  { label: 'Poistettu', value: 'deleted' },
]

// Activity datetimes are stored as bare 'YYYY-MM-DDTHH:mm' strings and treated
// as UTC wall-clock everywhere else. The DataGrid dateTime editor displays a
// Date in local time, so we mirror the UTC components into a local Date and
// reverse the trick on save — keeps the picker showing the same time as the
// cell formatter regardless of the user's timezone.
const utcStringToLocalDate = (value) => {
  if (!value) return null
  const m = moment.utc(value)
  if (!m.isValid()) return null
  return new Date(m.year(), m.month(), m.date(), m.hour(), m.minute())
}

const localDateToUtcString = (date) => {
  if (!date) return ''
  return moment
    .utc([date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes()])
    .format('YYYY-MM-DDTHH:mm')
}

// The mirrored Date's wall clock as a moment, for formatting and the picker. moment(date)
// would read the instant in moment's *global* zone, which the calendar views pin to a fixed
// UTC+3 (moment.tz.setDefault) - one hour off from the browser's own zone whenever Finland is
// on winter time, so every date after the DST change showed an hour late. Building from the
// components keeps the same wall clock whatever the global zone is.
const wallClock = (date) =>
  moment([date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes()])

const formatWallClock = (date) => (date ? wallClock(date).format('D.M.YY HH:mm') : '')

const wallClockToLocalDate = (m) => new Date(m.year(), m.month(), m.date(), m.hour(), m.minute())

// Picker-only edit cell for datetime columns: the modal opens immediately,
// the underlying text field is read-only, and changes are committed only when
// the user clicks OK (onAccept). Dismissing the modal cancels.
function DateTimeEditCell({ id, field, value }) {
  const apiRef = useGridApiContext()
  const acceptedRef = React.useRef(false)
  return (
    <LocalizationProvider dateAdapter={AdapterMoment}>
      <MobileDateTimePicker
        open
        ampm={false}
        value={value ? wallClock(value) : null}
        onChange={(newValue) => {
          apiRef.current.setEditCellValue({
            id,
            field,
            // back to the mirrored local Date by its components, not toDate(): see wallClock
            value: newValue && newValue.isValid() ? wallClockToLocalDate(newValue) : null,
          })
        }}
        onAccept={() => {
          acceptedRef.current = true
        }}
        onClose={() => {
          apiRef.current.stopCellEditMode({ id, field, ignoreModifications: !acceptedRef.current })
        }}
        slotProps={{
          textField: { variant: 'standard', size: 'small', sx: { width: '100%' } },
        }}
      />
    </LocalizationProvider>
  )
}

// MUI DataGrid compact metrics: 36 px rows, plus a fixed header and footer.
const GRID_ROW_HEIGHT = 36
const GRID_HEADER_HEIGHT = 56
const GRID_FOOTER_HEIGHT = 53
const MIN_PAGE_SIZE = 5

class ActivitiesContainer extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      loading: true,
      activityModalOpen: false,
      images: [],
      activityDetailsWizardOpen: false,
      activityDetailsOpen: false,
      selectedActivity: null,
      // Pre-filled form data for a copy. Only set while the create Stepper is open
      // for a "Kopioi"; a plain "Lisää tapahtuma" clears it.
      copySource: null,
      // The activity awaiting copy confirmation; null when the dialog is closed.
      copyTarget: null,
      // Activity awaiting a decision about its court bookings before deletion.
      deleteTarget: null,
      releasing: false,
      newrecurrent: false,
      activityFilter: 'upcoming',
      filtered: [],
      focusTab: 0,
      deleteLoading: {},
      debugActivity: null,
      // Controlled so the page survives opening the wizard. The container itself stays
      // mounted - only the render branch changes - so state is enough.
      paginationModel: { page: 0, pageSize: 25 },
      // Cancelled activities were always listed; they are now behind a toggle, off by
      // default, matching the Kalenteri convention.
      showcancelled: false,
      // The sort the user picked from a column header; null = the filter's default (start,
      // ascending for Tulevat, descending for Menneet). Switching the filter resets it.
      sortModel: null,
    }
    // Not state: it must not trigger a render, and it is read in componentDidUpdate.
    this.pendingScrollTop = null
    this.sortModel = null
  }

  // The sort model must keep a STABLE IDENTITY across renders. As a fresh array literal in
  // render, the DataGrid saw the sort as changing every time and reset the page to 0 - which
  // made controlled pagination impossible: each page click re-rendered the parent, which
  // handed the grid a new array, which sent it straight back to page 1 of the results.
  // A model the user picked is kept in state, which gives it the same stable identity.
  getSortModel = () => {
    if (this.state.sortModel) return this.state.sortModel
    const sort = this.state.activityFilter === 'past' ? 'desc' : 'asc'
    if (!this.sortModel || this.sortModel[0].sort !== sort) {
      this.sortModel = [{ field: 'start', sort }]
    }
    return this.sortModel
  }

  // The wizard replaces the list rather than overlaying it, so the scroll container's content
  // shrinks and the offset is clamped away. Put it back once the list is tall again -
  // restorePanelScroll retries, because the DataGrid has not measured its rows at this commit
  // and one assignment would just clamp against a panel that is still short.
  gridRef = React.createRef()

  componentWillUnmount() {
    window.removeEventListener('resize', this.updatePageSize)
  }

  componentDidUpdate(prevProps, prevState) {
    // Opening a detail view starts at the top. The panel keeps whatever offset the list had,
    // so the edit or participants view would otherwise open already scrolled down - the list
    // position is remembered for the way back, not carried into the view itself.
    const openedWizard = !prevState.activityDetailsWizardOpen && this.state.activityDetailsWizardOpen
    const openedDetails = !prevState.activityDetailsOpen && this.state.activityDetailsOpen
    if (openedWizard || openedDetails) {
      setPanelScrollTop(0)
      // Once more after paint, in case the panel is still settling from the branch swap.
      requestAnimationFrame(() => setPanelScrollTop(0))
      return
    }
    if (this.pendingScrollTop === null) return
    if (this.state.activityDetailsWizardOpen || this.state.activityDetailsOpen) return
    const top = this.pendingScrollTop
    this.pendingScrollTop = null
    restorePanelScroll(top)
  }

  componentDidMount() {
    this.updateData()
    this.updatePageSize()
    window.addEventListener('resize', this.updatePageSize)
    this.props.firebase.listenMedia().onSnapshot((snapshot) => {
      const images = []
      snapshot.forEach((doc) => {
        if (doc.data().mimetype.indexOf('image/') > -1) {
          images.push({ id: doc.id, ...doc.data() })
        }
      })
      this.setState({ images })
    })
    this.props.firebase.getSports().onSnapshot((doc) => {
      const sports = [...DEFAULT_SPORTS]
      if (doc.exists) {
        sports.push(...doc.data().list)
      }
      // unique array of sports
      const uniqueSports = [...new Map(sports.map((item) => [item['key'], item])).values()]
      uniqueSports.sort((a, b) => a.label.localeCompare(b.label))
      this.setState({ sports: uniqueSports })
    })
    this.props.firebase.getActivitytypes().onSnapshot((doc) => {
      const activitytypes = [...DEFAULT_TYPES]
      if (doc.exists) {
        activitytypes.push(...doc.data().list)
      }
      const uniqueActivitytypes = [...new Map(activitytypes.map((item) => [item['key'], item])).values()]
      uniqueActivitytypes.sort((a, b) => a.label.localeCompare(b.label))
      this.setState({ activitytypes: uniqueActivitytypes })
    })
  }

  updateData = async () => {
    const _activities = await this.props.firebase.getActivities()
    let _d = _activities.docs.map((sh) => {
      return { ...sh.data(), id: sh.id }
    })
    this.setState(
      {
        activities: _d,
      },
      () => {
        this.filterData()
        this.openFromLink()
      }
    )
  }

  // ?activity=<id>[&tab=participants] opens that activity, e.g. from a person's Aktiviteetit
  // tab. The query is removed once used, so closing the activity does not reopen it.
  openFromLink = () => {
    const params = new URLSearchParams(window.location.search)
    const id = params.get('activity')
    if (!id) return
    const tab = params.get('tab')
    window.history.replaceState(window.history.state, '', window.location.pathname)
    if (!this.state.activities.some((a) => a.id === id)) return
    if (tab === 'participants') this.handleRowParticipants(id)
    else this.handleRowEdit(id)
  }

  // Compact rows are 36 px and the header/footer take a fixed slice; measuring the real
  // container beats guessing from window.innerHeight, which ignores the navbar, the
  // filter chips and whatever else sits above the grid.
  updatePageSize = () => {
    const node = this.gridRef.current
    if (!node) return
    const available = node.clientHeight - GRID_HEADER_HEIGHT - GRID_FOOTER_HEIGHT
    const fits = Math.floor(available / GRID_ROW_HEIGHT)
    const pageSize = Math.max(MIN_PAGE_SIZE, fits)
    if (pageSize !== this.state.paginationModel.pageSize) {
      this.setState({ paginationModel: { ...this.state.paginationModel, page: 0, pageSize } })
    }
  }

  // The fitted size must appear in the options or MUI warns that pageSize is not one
  // of them.
  getPageSizeOptions = () => {
    const fitted = this.state.paginationModel.pageSize
    return Array.from(new Set([fitted, 25, 50, 100])).sort((a, b) => a - b)
  }

  filterData = () => {
    // UTC wall clock, like the stored times (utils/activityPast.js)
    const now = wallClockNow()
    const all = this.state.activities
      .map((r) => {
        r.displayName = r.name.fi
        r.desc = r.description.fi
        r.ingr = r.ingress.fi
        r.participantscount = r.participants ? r.participants.length : 0
        r.queuecount = r.queue ? r.queue.length : 0
        // r.actions = this.getActions(r.id)
        r.state = r.state ? r.state : 'published'
        // r.statelabel = STATES.find((s) => s.value === r.state).label
        // if (r.resourceconfigid) {
        //   let _rc = this.state.resourceconfigurations.find((rc) => rc.id === r.resourceconfigid)
        //   if (_rc) {
        //     r.resourceconfigname = _rc.displayName
        //   } else {
        //     r.resourceconfigname = 'default'
        //   }
        // } else {
        //   r.resourceconfigname = 'default'
        // }
        // if (r.multiuse && r.multiuse.length > 0) {
        //   r.multiusecourt = 'Kyllä'
        // } else {
        //   r.multiusecourt = 'Ei'
        // }
        return {
          ...r,
        }
      })
    const _data = all
      .filter((r) => this.state.showcancelled || r.state !== 'cancelled')
      .filter((r) => {
        const isPast = isActivityPast(r, now)
        return this.state.activityFilter === 'past' ? isPast : !isPast
      })
      .sort((a, b) => {
        const aStart = moment.utc(a.start, 'YYYY-MM-DDTHH:mm')
        const bStart = moment.utc(b.start, 'YYYY-MM-DDTHH:mm')
        return this.state.activityFilter === 'past' ? bStart.diff(aStart) : aStart.diff(bStart)
      })

    // From the whole list, not just the filtered rows: an activity opened through a link (e.g.
    // a person's Aktiviteetit tab) can be past or cancelled, outside the current filter, and
    // would otherwise never pick up its new payments or participants.
    let updatedSelectedActivity = null
    if (this.state.selectedActivity) {
      updatedSelectedActivity = all.find((r) => r.id === this.state.selectedActivity.id)
    }
    if (updatedSelectedActivity) {
      this.setState({ filtered: _data, selectedActivity: updatedSelectedActivity, loading: false })
    } else {
      this.setState({ filtered: _data, loading: false })
    }
  }

  handleRowEdit = (e) => {
    const activity = this.state.activities.find((r) => r.id === e)
    console.log('handleRowEdit', activity)
    this.setState({ selectedActivity: activity }, this.toggleActivityDetailsWizard)
  }

  handleRowSelect = (e) => {
    const activity = this.state.activities.find((r) => r.id === e)
    this.setState({ selectedActivity: activity }, this.toggleActivityDetails) //this.toggleActivityModal)
  }

  handleRowParticipants = (e) => {
    const activity = this.state.activities.find((r) => r.id === e)
    // The wizard hides the 'Osallistujat' tab for external activities, so fall
    // back to the first tab instead of selecting a tab that isn't rendered.
    const focusTab = activity && activity.isexternal ? 0 : 1
    this.setState({ selectedActivity: activity, focusTab }, this.toggleActivityDetailsWizard)
  }

  processRowUpdate = async (newRow, oldRow) => {
    const editableFields = ['minp', 'maxp', 'start', 'entryend']
    const norm = (v) => (v instanceof Date ? v.toISOString() : v)
    const changed = editableFields.some((f) => norm(newRow[f]) !== norm(oldRow[f]))
    if (!changed) return oldRow
    const payload = { ...newRow }
    ;['start', 'entryend'].forEach((f) => {
      if (payload[f] instanceof Date) {
        payload[f] = localDateToUtcString(payload[f])
      }
    })
    // moving the entry end earlier must not leave an own cancellation deadline after it
    const deadlineError = cancellationEndError(payload)
    if (deadlineError) {
      alert(deadlineError + '. Muuta ensin peruutuksen takarajaa aktiviteetin tiedoista.')
      return oldRow
    }
    await this.props.firebase.updateActivity(payload)
    const activities = this.state.activities.map((a) =>
      a.id === payload.id ? { ...a, ...payload } : a
    )
    this.setState({ activities }, this.filterData)
    return newRow
  }


  addNewActivity = () => {
    this.setState({ selectedActivity: null, newrecurrent: false, copySource: null }, this.toggleActivityDetailsWizard)
    // this.setState({ selectedActivity: {} }, this.toggleActivityModal)
  }

  addNewActivityRecurrent = () => {
    this.setState({ selectedActivity: null, newrecurrent: true, copySource: null }, this.toggleActivityDetailsWizard)
    // this.setState({ selectedActivity: {} }, this.toggleActivityModal)
  }

  // Copy opens the create Stepper pre-filled instead of writing anything: the user
  // still has to pick the new times and click through, so an abandoned copy leaves
  // nothing behind.
  handleRowCopy = (id) => {
    const activity = this.state.activities.find((r) => r.id === id)
    if (!activity) return
    this.setState({ copyTarget: activity })
  }

  cancelCopy = () => this.setState({ copyTarget: null })

  confirmCopy = () => {
    const activity = this.state.copyTarget
    if (!activity) return
    this.setState(
      {
        copyTarget: null,
        selectedActivity: null,
        newrecurrent: false,
        copySource: buildActivityCopy(activity),
      },
      this.toggleActivityDetailsWizard
    )
  }

  renderCopyDialog = () => (
    <ActivityCopyDialog
      open={!!this.state.copyTarget}
      onClose={this.cancelCopy}
      onConfirm={this.confirmCopy}
      activityName={this.state.copyTarget && this.state.copyTarget.name ? this.state.copyTarget.name.fi : ''}
    />
  )

  toggleActivityModal = () => {
    this.setState({
      activityModalOpen: !this.state.activityModalOpen,
    })
  }

  toggleActivityDetails = () => {
    // Same capture as the wizard, so the Details view returns to the list position too.
    if (!this.state.activityDetailsOpen) this.pendingScrollTop = getPanelScrollTop()
    this.setState({
      activityDetailsOpen: !this.state.activityDetailsOpen,
    })
  }

  toggleActivityDetailsWizard = () => {
    const closing = this.state.activityDetailsWizardOpen
    // Remember where the list was on the way in; componentDidUpdate restores it on the way
    // back. All four entries into the wizard funnel through here, as does Palaa listaan.
    if (!closing) this.pendingScrollTop = getPanelScrollTop()
    this.setState({
      activityDetailsWizardOpen: !closing,
      // Reset the tab on close only — when opening, keep the tab the caller
      // asked for (handleRowParticipants sets focusTab before toggling).
      ...(closing ? { focusTab: 0, copySource: null } : {}),
    }, closing ? this.updateData : undefined)
  }

  handleDeleteActivity = async (id) => {
    const activity = this.state.activities.find((r) => r.id === id)
    const features = this.props.customerdata ? this.props.customerdata.features : null
    // Deleting an activity that still holds court bookings would either strand them or
    // silently free them; both are wrong some of the time, so ask.
    if (activity && features && features.activityattaching && createdReservations(activity.reservations).length > 0) {
      this.setState({ deleteTarget: activity })
      return
    }
    this.deleteActivityNow(id, false)
  }

  deleteActivityNow = async (id, release) => {
    this.setState({ deleteLoading: { ...this.state.deleteLoading, [id]: true }, releasing: !!release })
    if (release) {
      const activity = this.state.activities.find((r) => r.id === id)
      const releasable = createdReservations(activity ? activity.reservations : [])
      for (let i = 0; i < releasable.length; i++) {
        await this.props.firebase.cancelActivityReservation(releasable[i].id)
      }
    }
    await this.props.firebase.deleteActivity(id)
    this.setState(
      { deleteLoading: { ...this.state.deleteLoading, [id]: false }, deleteTarget: null, releasing: false },
      this.updateData
    )
  }

  renderReleaseDialog = () => (
    <ActivityReservationReleaseDialog
      open={!!this.state.deleteTarget}
      reservations={createdReservations(this.state.deleteTarget ? this.state.deleteTarget.reservations : [])}
      working={this.state.releasing}
      onCancel={() => this.setState({ deleteTarget: null })}
      onKeep={() => this.deleteActivityNow(this.state.deleteTarget.id, false)}
      onRelease={() => this.deleteActivityNow(this.state.deleteTarget.id, true)}
    />
  )

  // getCategoryDeps = () => {
  //   if (this.state.resourcecategories) {
  //     const keys = Object.keys(this.state.resourcecategories)
  //     return keys.map((key) => {
  //       const enumNames = this.state.resourcecategories[key]
  //       const enums = enumNames.map((e) => e.toLowerCase())
  //       const dep = {
  //         properties: {
  //           type: {
  //             enum: [key],
  //           },
  //           category: {
  //             type: 'string',
  //             title: 'Kategoria',
  //             enum: enums,
  //             enumNames: enumNames,
  //           },
  //         },
  //       }
  //       return dep
  //     })
  //   }
  // }

  getDataSchemaWithImagesList = () => {
    const dataSchema = getActivitySchema()
    dataSchema.properties.image = {
      type: 'string',
      title: 'Kuva',
      oneOf: this.state.images.map((x) => ({ const: x.id, title: x.originalName })),
    }
    return dataSchema
  }

  createActivity = async (data) => {
    const _data = { ...data }
    if (!_data.description) _data.description = { fi: '', en: '', sv: '' }
    if (!_data.ingress) _data.ingress = { fi: '', en: '', sv: '' }
    if (!_data.name) _data.name = { fi: '', en: '', sv: '' }
    _data.ingress.fi = _data.ingr
    _data.name.fi = _data.displayName
    _data.description.fi = _data.desc
    delete _data.displayName
    delete _data.desc
    delete _data.ingr

    await this.props.firebase.createActivity(_data)
  }

  createActivityModal = () => {
    const schema = this.getDataSchemaWithImagesList()
    // schema.dependencies.type.oneOf = this.getCategoryDeps()

    // const items = { oneOf: [] }
    // this.state.resources.sort((a, b) => a.displayName.localeCompare(b.displayName)).forEach((res) => {
    //   items.enum.push(res.id)
    //   items.enumNames.push(res.displayName)
    // })
    // schema.properties.multiuse.items = items

    // const rcItems = { oneOf: [] }
    // this.state.resourceconfigurations.sort((a, b) => a.displayName.localeCompare(b.displayName)).forEach((res) => {
    //   rcItems.enum.push(res.id)
    //   rcItems.enumNames.push(res.displayName)
    // })
    // schema.properties.resourceconfigid.enum = rcItems.enum
    // schema.properties.resourceconfigid.enumNames = rcItems.enumNames

    return (
      <FalconModal
        onUpdate={this.props.firebase.updateActivity}
        onCreate={this.props.firebase.createActivity}
        toggle={this.toggleActivityModal}
        size='xl'
        modifiedCallback={this.updateData}
        resource={this.state.selectedActivity}
        isOpen={this.state.activityModalOpen}
        uiSchema={getActivityUISchema()}
        dataSchema={schema}
        title={
          this.state.selectedActivity && this.state.selectedActivity.id ? 'Muokkaa aktiviteettia' : 'Uusi aktiviteetti'
        }
      />
    )
  }

  getActions = (id) => {
    return (
      <>
        <div className='actions-right'>
          <EditButton
            onClick={(el) => {
              this.handleRowEdit(id)
            }}
          />
          <Button
            color='info'
            size='sm'
            onClick={(el) => {
              this.handleRowSelect(id)
            }}
          >
            <span className='btn-label'>
              <i className='nc-icon nc-simple-remove' /> Details
            </span>
          </Button>
        </div>
      </>
    )
  }

  getColDefinitions = () => {
    const cols = [
      {
        headerName: ' ',
        field: 'edit',
        disableClickEventBubbling: true,
        renderCell: (params) => {
          return <EditButton onClick={() => this.handleRowEdit(params.row.id)} />
        },
        width: 120,
        sortable: false,
        filterable: false,
      },
      {
        headerName: ' ',
        field: 'participants',
        disableClickEventBubbling: true,
        renderCell: (params) => {
          return <ParticipantsButton onClick={() => this.handleRowParticipants(params.row.id)}/>
        },
        width: 60,
        sortable: false,
        filterable: false,
      },
      {
        headerName: ' ',
        field: 'copy',
        disableClickEventBubbling: true,
        renderCell: (params) => {
          return <CopyButton onClick={() => this.handleRowCopy(params.row.id)} />
        },
        width: 60,
        sortable: false,
        filterable: false,
      },
      {
        // the activity image: the smallest generated size of the library image (media),
        // or the poster url itself when the image has no sizes
        headerName: 'Kuva',
        field: 'poster',
        width: 50,
        sortable: false,
        filterable: false,
        renderCell: (params) => {
          const src = imageThumbnailUrl(params.row.media) || params.row.poster
          if (!src) return null
          return (
            <Box
              component='img'
              src={src}
              alt=''
              loading='lazy'
              sx={{ width: 28, height: 28, objectFit: 'cover', borderRadius: 0.5, display: 'block', mt: '4px' }}
            />
          )
        },
      },
      {
        headerName: 'Nimi',
        field: 'displayName',
        disableClickEventBubbling: true,
        // maxWidth: 400,
        minWidth: 300,
      },
      // {
      //   headerName: 'Tyyppi',
      //   field: 'type',
      //   disableClickEventBubbling: true,
      //   minWidth: 140,
      // },
      {
        headerName: 'Alkamisaika',
        field: 'start',
        type: 'dateTime',
        editable: true,
        disableClickEventBubbling: true,
        valueGetter: utcStringToLocalDate,
        valueFormatter: (value) => formatWallClock(value),
        renderEditCell: (params) => <DateTimeEditCell {...params} />,
        minWidth: 160,
      },
      {
        headerName: 'Laji',
        field: 'sport',
        minWidth: 120,
      },
      {
        // Free text the venue writes, emoji included - no formatting to interpret, so the
        // default cell renderer is the whole of it.
        headerName: 'Taso',
        field: 'skillLevel',
        minWidth: 120,
      },
      {
        headerName: 'Max',
        field: 'maxp',
        width: 60,
        type: 'number',
        editable: true,
        filterable: false,
        sortable: false,
      },
      {
        headerName: 'Min',
        field: 'minp',
        width: 60,
        type: 'number',
        editable: true,
        filterable: false,
        sortable: false,
      },
      {
        headerName: 'Ilmot',
        field: 'participantscount',
        width: 60,
        // type: 'number',
        sortable: false,
        filterable: false,
      },
      {
        headerName: 'Jono',
        field: 'queuecount',
        width: 60,
        // type: 'number',
        sortable: false,
        filterable: false,
      },
      {
        headerName: 'Sulkeutuu',
        field: 'entryend',
        type: 'dateTime',
        editable: true,
        valueGetter: utcStringToLocalDate,
        valueFormatter: (value) => formatWallClock(value),
        renderEditCell: (params) => <DateTimeEditCell {...params} />,
        minWidth: 160,
      },
      {
        // When the activity has no own deadline, cancelling follows the entry end: show that
        // date dimmed, so the column is never empty but an own deadline stands out.
        headerName: 'Peruutus päättyy',
        field: 'cancellationend',
        type: 'dateTime',
        valueGetter: (value, row) => utcStringToLocalDate(effectiveCancellationEnd(row)),
        renderCell: (params) => {
          if (!params.value) return ''
          const text = formatWallClock(params.value)
          return hasOwnCancellationEnd(params.row) ? (
            text
          ) : (
            <span style={{ color: '#9a9a9a' }} title='Sama kuin ilmoittautumisen päättyminen'>
              {text}
            </span>
          )
        },
        minWidth: 140,
      },
      {
        headerName: 'Ohjaaja',
        field: 'organisers',
        minWidth: 180,
        valueGetter: (value) => {
          if (!Array.isArray(value)) return ''
          return value
            .map((o) => [o.firstname, o.lastname].filter(Boolean).join(' ').trim())
            .filter(Boolean)
            .join(', ')
        },
      },
      {
        headerName: 'Tila',
        field: 'state',
        disableClickEventBubbling: true,
        valueFormatter: (value) => {
          const s = STATES.find((x) => x.value === value)
          return s ? s.label : ''
        },
      },
      {
        headerName: ' ',
        field: 'delete',
        disableClickEventBubbling: true,
        renderCell: (params) => {
          return <DeleteButton loading={this.state.deleteLoading[params.row.id]} onClick={() => this.handleDeleteActivity(params.row.id)} />
        },
        width: 120,
        sortable: false,
        filterable: false,
      },
    ]
    if (process.env.NODE_ENV === 'development') {
      cols.push({
        headerName: ' ',
        field: 'debug',
        disableClickEventBubbling: true,
        renderCell: (params) => (
          <IconButton
            size='small'
            title='Näytä JSON (debug)'
            onClick={() => this.setState({ debugActivity: params.row })}
          >
            <BugReportIcon fontSize='small' />
          </IconButton>
        ),
        width: 60,
        sortable: false,
        filterable: false,
      })
    }
    return cols.map((x) => {
      // return { ...x, flex: 1 / cols.length }
      return { ...x }
    })
  }

  render() {
    if (this.state.loading) {
      return (
        <>
          <div className='content'>
            <Row>
              <Col>Loading ...</Col>
            </Row>
          </div>
        </>
      )
    } else if (this.state.activityDetailsOpen) {
      return (
        <>
          <div className='content'>
            <Row>
              <Col>
                <ActivityDetails activity={this.state.selectedActivity} />
              </Col>
            </Row>
          </div>
        </>
      )
    } else if (this.state.activityDetailsWizardOpen) {
      return (
        <>
          <div className='content'>
            <Row>
              <Col>
                <Button onClick={this.toggleActivityDetailsWizard}>Palaa listaan</Button>
              </Col>
            </Row>
            <ActivityDetailsWizard
              sports={this.state.sports}
              activitytypes={this.state.activitytypes}
              // firebase={this.props.firebase}
              activity={this.state.selectedActivity}
              initialActivity={this.state.copySource}
              customerdata={this.props.customerdata}
              profile={this.props.profile}
              user={this.props.user}
              // onChangeActivity={(a) => this.setState({ selectedActivity: a })}
              // closeDetail={this.closeDetail}
              images={this.state.images}
              onUpdate={this.updateData}
              onClose={this.toggleActivityDetailsWizard}
              recurrent={this.state.newrecurrent}
              initTab={this.state.focusTab}
            />
          </div>
        </>
      )
    } else {
      return (
        <div className='content'>
          <Row className='mb-2'>
            <Col>
              <Button size='sm' onClick={this.addNewActivity}>Lisää tapahtuma/aktiviteetti</Button>{' '}
              <Button size='sm' onClick={this.addNewActivityRecurrent}>Lisää toistuva</Button>
            </Col>
            <Col className='mt-2'>
              <Infobox index={'0'} />
            </Col>
          </Row>
          <Row>
            <Col className='align-bottom align-text-bottom mb-2'>
              <Chip
                label='Tulevat'
                clickable
                size='small'
                color='primary'
                variant={this.state.activityFilter === 'upcoming' ? 'default' : 'outlined'}
                onClick={() => this.setState({ activityFilter: 'upcoming', sortModel: null }, this.filterData)}
                style={{ marginRight: 4 }}
              />
              <Chip
                label='Menneet'
                clickable
                size='small'
                color='primary'
                variant={this.state.activityFilter === 'past' ? 'default' : 'outlined'}
                onClick={() => this.setState({ activityFilter: 'past', sortModel: null }, this.filterData)}
              />
            </Col>
            <Col xs='auto' className='mb-2'>
              <FormControlLabel
                control={
                  <Switch
                    size='small'
                    checked={this.state.showcancelled}
                    onChange={(e) => this.setState({ showcancelled: e.target.checked }, this.filterData)}
                  />
                }
                label={<span style={{ fontSize: 13 }}>Näytä perutut</span>}
              />
            </Col>
          </Row>
          <Row>
            <Col xs='12'>
              <div
                ref={this.gridRef}
                style={{ display: 'flex', minHeight: 'calc(100vh - 200px)', backgroundColor: '#FFFFFF' }}
              >
                <div style={{ flexGrow: 1, minWidth: 0 }}>
                  <DataGrid
                    rows={this.state.filtered}
                    columns={this.getColDefinitions()}
                    density='compact'
                    sortModel={this.getSortModel()}
                    onSortModelChange={(sortModel) => this.setState({ sortModel })}
                    paginationModel={this.state.paginationModel}
                    pageSizeOptions={this.getPageSizeOptions()}
                    onPaginationModelChange={(paginationModel) => this.setState({ paginationModel })}
                    processRowUpdate={this.processRowUpdate}
                    onProcessRowUpdateError={(err) => console.error('Activity row update failed', err)}
                  />
                </div>
              </div>
            </Col>
          </Row>
          <Row>
            <Col md='12'></Col>
          </Row>
          {this.state.alert}
          {this.createActivityModal()}
          {this.renderCopyDialog()}
          {this.renderReleaseDialog()}
          <Dialog
            open={!!this.state.debugActivity}
            onClose={() => this.setState({ debugActivity: null })}
            maxWidth='md'
            fullWidth
          >
            <DialogTitle>Activity JSON (debug)</DialogTitle>
            <DialogContent>
              <pre style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word', fontSize: 12 }}>
                {JSON.stringify(this.state.debugActivity, null, 2)}
              </pre>
            </DialogContent>
          </Dialog>
        </div>
      )
    }
  }
}

export default withFirebase(ActivitiesContainer)
